// https://github.com/vercel/next.js/issues/77291

export enum ClientType {
  Platform = 'PLATFORM',
  Matrix = 'MATRIX',
  MatrixNative = 'MATRIX_NATIVE',
  DeltaMatrix = 'DELTA_MATRIX',
  DeltaPlatform = 'DELTA_PLATFORM',
  WebSdk = 'WEB_SDK',
  CsrApp = 'CSR_APP',
}

export type ClientContextValue =
  | {
      /**
       * The client who's rendering the app
       */
      client?: ClientType.Platform | ClientType.Matrix | ClientType.MatrixNative;
      /**
       * The app inside which the client is rendering
       * Not applicable for PLATFORM or MATRIX
       */
      app?: never;
      value?: {
        client?: ClientType.Platform | ClientType.Matrix | ClientType.MatrixNative;
        app?: never;
      };
    }
  | {
      /**
       * The client who's rendering the app
       */
      client:
        | ClientType.DeltaMatrix
        | ClientType.DeltaPlatform
        | ClientType.WebSdk
        | ClientType.CsrApp;
      /**
       * The app inside which the client is rendering
       */
      app: 'SALESFORCE' | 'SHOPIFY' | 'ZENDESK' | 'UNKNOWN'; // `app` is required for these clients
    };
